import { ListMessageSetVersions, ListMessageSetVersionsVariables } from './__generated__/ListMessageSetVersions'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query ListMessageSetVersions($input: ListMessageSetVersionInputV2!) {
    listMessageSetVersionsV2(input: $input) {
      versions {
        id
        title
      }
      nextCursor
    }
  }
`

export const useListMessageSetVersions = (variables: ListMessageSetVersionsVariables) => {
  return useQuery<ListMessageSetVersions, ListMessageSetVersionsVariables>(QUERY, {
    fetchPolicy: 'network-only',
    variables
  })
}
